import { Controller } from "@hotwired/stimulus";

/**
 * フォームの入力中にページを離れる際にメッセージを表示する
 * @example
 * <form data-controller="form-confirmation">
 *  <a data-action="form-confirmation#confirm">リンク</a>
 * </form>
 * または
 * <div data-controller="form-confirmation">
 *   <form data-form-confirmation-target="form"></form>
 *   <a data-action="form-confirmation#confirm">リンク</a>
 * </div>
 */
export class FormConfirmationController extends Controller {
  static targets = ["form"];
  static values = {
    message: { type: String, default: "このページを離れますか？" },
  };

  #isDirty = false;

  connect() {
    this.#isDirty = false;
    for (const form of this.#forms) {
      form.addEventListener("input", this.#handleInput);
      form.addEventListener("submit", this.#handleSubmit);
    }
  }

  disconnect() {
    for (const form of this.#forms) {
      form.removeEventListener("input", this.#handleInput);
      form.removeEventListener("submit", this.#handleSubmit);
    }
  }

  confirm(e) {
    if (!this.#isDirty) return;
    if (!confirm(this.messageValue)) {
      e.preventDefault();
    }
  }

  get #forms() {
    return this.hasFormTarget ? this.formTargets : [this.element];
  }

  // 何か入力されたらフラグを立てる
  #handleInput = () => {
    this.#isDirty = true;
  };

  // 送信したら解除
  #handleSubmit = () => {
    this.#isDirty = false;
  };
}
